const mEditionBillingAcademyClients = {
  mEditionBillingAcademyClients: {
    alerts: {
      readClientsExportar: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de clientes descargado.'
      },

      readClientes: {
        error: 'La academia que buscas con esa url no existe'
      }
    },

    buttonPrimary: 'Descargar CSV',

    files: {
      clients: 'Clientes'
    },

    table: {
      ars: 'ARS',
      eur: 'EUR',
      usd: 'USD',
      mxn: 'MXN',
      client: 'Cliente',
      lastSale: 'Último pago',
      products: 'Prods.',
      view: 'Ver'
    },

    tooltip: {
      restart: 'Reset'
    }
  }
}
export default mEditionBillingAcademyClients
